module.exports = "/static/assets/ac92bfcb2fc35687d1ba5ab6bb733671.svg";